export default {"src":"/_next/static/media/percentages.5af55d36.svg","height":598,"width":701};